export const en = {
    translation: {
        b: {
            cancel: 'Cancel',
            confirm: 'Confirm',
            send: 'Send',
            done: 'Done',
            close: 'Close',
            clear: 'Clear',
            copy_link: 'Copy Link',
            export: 'Export',
            delete: 'Delete',
            delete_confirm: 'Confirm Delete',
            duplicate: 'Duplicate',
            share: 'Share',
            sign_in: 'Sign In',
            sign_up: 'Sign Up',
            email_address: 'Email address',
            yes: 'Yes',
            no: 'No',
            back: 'Back',
            upgrade: 'Upgrade',
            remove: 'Remove',
            restore: 'Restore',
            archive: 'Archive',
            rename: 'Rename',
            leave: 'Leave',
            import: 'Import',
            continue: 'Continue',
            settings: 'Settings',
            log_out: 'Log out',
            invite: 'Invite',
            invited: 'Invited',
        },
        roles: {
            view: 'Viewer',
            comment: 'Commenter',
            edit: 'Editor',
            admin: 'Admin',
            owner: 'Owner',
            member: 'Member',
            remove: 'Remove',
            more_roles: 'More roles...',
            change_role: 'Change role...',
            remove_access: 'Remove access...',
            remove_invite: 'Remove invite...',
        },
        db_engine: {
            basic: 'Basic SQL',
            general: 'General SQL',
        },
        socket_status: {
            reconnecting: 'Reconnecting...',
            offline: "You're offline. Reconnecting...",
        },
        loader: {
            diagram: 'Loading diagram...',
        },
        m_languages: {
            title: 'Languages',
            subtitle: 'Choose a language',
        },
        m_feedback: {
            feature: {
                name: 'Feature Request',
                desc: 'Missing a feature you need? Let us know — your ideas matter',
            },
            feedback: {
                name: 'Share your feedback',
                desc: 'We would love to hear what you think',
            },
            support: {
                name: 'Support',
                desc: "Something’s not working? Let us know — we’ll fix it fast",
            },
            bug: {
                name: 'Report Issue',
                desc: "Something not quite right? Report it — we’ll handle it quickly",
            },
            integration: {
                name: 'Request Integration',
                desc: "Your feedback means the world to us — drop a quick note",
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Thank you for your suggestion!',
                desc: 'We truly appreciate you taking the time to share your thoughts — it helps us make things better.',
            },
            feedback: {
                name: 'Thank you for your feedback!',
                desc: 'We truly appreciate you taking the time to share your thoughts — it helps us make things better.',
            },
            support: {
                name: 'Thank you for reaching out!',
                desc: "Thank you for contacting support — we’ll review your request and respond as soon as we can.",
            },
            bug: {
                name: 'Thank you for your report!',
                desc: "Thank you for reporting this — it helps us fix issues faster and keep improving the experience.",
            },
            contact: {
                name: 'Thank you for getting in touch!',
                desc: "We’ve received your message and will get back to you as soon as we can.",
            },
            invite_people: {
                name: 'Invite sent successfully!',
                desc: "Thank you for spreading the word — we’re excited to welcome them aboard.",
            },
            integration: {
                name: 'Thank you for your suggestion!',
                desc: "We truly appreciate you taking the time to share your thoughts — it helps us make things better.",
            },
        },
        m_diagram_details: {
            name_place: 'Enter project name',
            desc_place: 'Enter project description',
        },
        m_quick_share: {
            title: 'Quick Share',
            subtitle: '(Query-based link sharing)',
        },
        m_export_img: {
            title: 'Export Image',
        },
        search_menu: {
            placeholder: 'Search tables, columns, types...',
            // placeholder: 'Type a command or search...',
            // hint: 'Type to search tables and columns',
            hint: '',
            no_results: 'No results',
            quick_results: 'Quick results for',
            untitled: 'untitled',
            command_tag: 'command',
            section_tables: 'Tables',
            section_columns: 'Columns',
            section_canvas: 'Canvas',
            section_export: 'Export',
            section_preferences: 'Preferences',
            section_settings: 'Settings',
            type_table: 'table',
            type_note: 'note',
            cmd_new_table: 'Create new table...',
            cmd_new_note: 'Create new note...',
            cmd_new_line: 'Create new line...',
            cmd_new_area: 'Create new area...',
            cmd_export_image: 'Export image...',
            cmd_export_sql: 'Export SQL Code...',
            cmd_grid_style: 'Change grid layout...',
        },
        canvas_table: {
            more_column: 'more column',
            more_columns: 'more columns',
            tooltip_table: 'Table',
            tooltip_indexes: 'Indexes',
            tooltip_enum: 'Enum',
            tooltip_default: 'Default',
            tooltip_generated: 'Generated',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Export Code – {{db_engine}}',
            download_file: 'Download File',
            copy_code: 'Copy Code',
        },
        m_sign_in_remind: {
            title: 'Thanks for trying DB Design',
            subtitle: 'Sign in or sign up to increase table limits, save diagrams, and unlock more features.',
        },
        m_sign_in_restrict: {
            title: 'Sign in to do more in the app',
            subtitle: 'Sign in or sign up to increase table limits, save diagrams, and unlock more features.',
        },
        m_new_diagram: {
            title: 'New diagram',
            subtitle: 'Choose a database engine',
            open_diagram: 'Open Diagram',
            create_diagram: 'Create Diagram',
            no_workspace: 'Create a workspace first to start a diagram.',
            build_something_new: "Let's build something new",
            create_diagram_section: 'Create diagram',
            clone_template_btn: 'Clone template',
        },
        m_diagram_name: {
            enter_new_name: 'Enter a new diagram name',
        },
        m_diagram_clone: {
            header: 'Duplicate diagram',
            copy_of_title: 'Copy of {{title}}',
        },
        m_diagram_rename: {
            header: 'Rename diagram',
        },
        m_template_clone: {
            header: 'Create a diagram from template',
        },
        m_diagram_delete: {
            header: 'Delete diagram',
            desc_prefix: 'This will delete ',
        },
        m_diagram_archive: {
            header: 'Archive diagram',
            desc_prefix: 'This will archive ',
        },
        m_diagram_restore: {
            header: 'Restore diagram',
            desc_prefix: 'This will restore ',
        },
        m_diagram_import: {
            sql_name: 'Import SQL Code',
            dbml_name: 'Import DBML Code',
            // NOTE: this placeholder copy ("We'd love to hear your thoughts!") reads like
            // it was copied from a feedback modal — it doesn't describe pasting SQL/DBML
            // code. Flagged in the i18n report as a likely content bug; kept as-is here
            // (translated verbatim, not rewritten) since fixing the copy is a product call.
            placeholder: "We’d love to hear your thoughts!",
        },
        m_diagram_not_found: {
            header: 'Diagram not found',
            desc: 'We could not find the diagram you are looking for.',
            back_to_app: 'Back to app',
        },
        m_diagram_share: {
            header: 'Share diagram – {{title}}',
            owner_only_invite: 'Only owner can invite new members',
            invited_to_workspace: 'Invited to the workspace',
            you: 'you',
            email_placeholder: 'Enter email',
            email_already_in_list: 'email is already in the list',
            will_be_invited_to_workspace: 'will be invited to the workspace',
        },
        m_invite_people: {
            header: 'Invite to workspace',
        },
        m_invite_revoke: {
            header: 'Remove invite',
            desc_prefix: 'Remove invite for ',
            desc_suffix: 'The invitation will stop working.',
        },
        m_member_remove: {
            header: 'Remove member',
            desc_prefix: 'Remove ',
            desc_suffix: "from this workspace? They'll lose access.",
        },
        m_template_details: {
            preview: 'Preview',
            use_template: 'Use template',
        },
        m_workspace_create: {
            header: 'Create a new workspace',
            name_label: 'Name',
            setup_config_label: 'Setup configuration',
            setup_config_value: 'Empty workspace',
            template_structure_label: 'Template/Structure',
            template_structure_value: 'Preload structure',
            placeholder: 'Enter workspace name',
            create_button: 'Create workspace',
            creating: 'Creating your workspace...',
        },
        m_workspace_delete: {
            header: 'Delete workspace',
            desc_prefix: 'This will permanently delete ',
            confirm_prefix: 'Type ',
            confirm_suffix: ' to confirm.',
        },
        m_workspace_leave: {
            header: 'Leave workspace',
            desc_prefix: 'This will remove you from ',
            desc_suffix: "You'll need to be re-invited to rejoin.",
        },
        m_workspace_menu: {
            manage_members: 'Manage members',
            switch_workspace: 'Switch workspace',
            workspaces_label: 'Workspaces',
            create_workspace: 'Create a workspace...',
            switching: 'Switching',
        },
        m_profile_menu: {
            profile: 'Profile',
            onboarding: 'Onboarding',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Level up your collaboration', description: 'Upgrade to unlock more sharing roles like Admin, Editor, Commenter, Viewer.' },
            workspaces: { title: "You're growing fast!", description: 'Upgrade to create and manage more workspaces for your projects and teams.' },
            workspaces_canvas: { title: 'Expand your workspaces', description: 'Upgrade to create and manage more workspaces for your projects and teams.' },
            members: { title: 'Collaborate at scale', description: 'Upgrade to bring more members into your workspace and collaborate more effectively.' },
            diagrams: { title: "You're growing fast!", description: 'Upgrade to create more diagrams and grow your projects with confidence.' },
            tables: { title: 'Create without limits', description: 'Upgrade to add more tables and continue building larger, more detailed diagrams.' },
            columns: { title: 'Create without limits', description: 'Upgrade to add more columns and continue building larger, more detailed diagrams.' },
            notes: { title: 'Create without limits', description: 'Upgrade to add more notes and continue building larger, more detailed diagrams.' },
            areas: { title: 'Create without limits', description: 'Upgrade to add more areas and continue building larger, more detailed diagrams.' },
            pens: { title: 'Create without limits', description: 'Upgrade to add more drawings and continue building larger, more detailed diagrams.' },
            default_title: 'Level up your collaboration',
            default_title_canvas: 'Level up your performance',
        },
        m_pricing_plans: {
            title: 'Upgrade your plan',
            subtitle: 'You can always upgrade or downgrade your plan later',
            monthly: 'Monthly',
            annually: 'Annually',
            billed_annually: 'Billed annually',
            billed_monthly: 'Billed monthly',
            free_for_everyone: 'Free for everyone',
            current_plan: 'Current plan',
            will_be_available_soon: 'Will be available soon',
            price_period_user_month: '/user/month',
            plan_free: {
                name: 'Free',
                button: 'Change plan',
                feature_realtime: 'Real-time collaboration',
                feature_members: '4 members / workspace',
                feature_diagrams: '4 diagrams / workspace',
                feature_tables: '40 tables / diagram',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'All Free features +',
                feature_members: 'Unlimited members',
                feature_diagrams: 'Unlimited diagrams',
                feature_tables: 'Unlimited tables',
                feature_history: 'Version history',
                feature_admin_roles: 'Admin roles',
            },
        },
        sidebar: {
            new: 'New',
            pinned_diagrams: 'Pinned diagrams',
            pin_hint: 'Pin diagrams to see them here',
            expand_sidebar: 'Expand sidebar',
            home_aria: 'DB Design home',
            open_menu: 'Open menu',
            close_menu: 'Close menu',
            sidebar_menu_aria: 'Sidebar menu',
            plan_suffix: 'plan',
            diagram_options: 'Diagram options',
            pin: 'Pin',
            unpin: 'Unpin',
            edit_details: 'Edit details',
            see_details: 'See details',
            invite_people: 'Invite people',
            collapse_sidebar: 'Collapse sidebar',
            close_sidebar: 'Close sidebar',
            open_sidebar: 'Open sidebar',
            open_new_tab: 'Open in new tab',
        },
        focus_controls: {
            show_top: 'Show top controls',
            hide_top: 'Hide top controls',
            show_left: 'Show left controls',
            hide_left: 'Hide left controls',
        },
        m_keyboard_shortcuts: {
            title: 'Keyboard Shortcuts',
            general: {
                title1: 'General',
                title2: '',
                items: {
                    new_diagram: 'Create diagram',
                    new_chat: 'New chat',
                    search: 'Quick actions or search',
                    preferences: 'Preferences',
                    settings: 'Settings',
                    keyboard_shortcuts: 'Keyboard shortcuts',
                    toggle_sidebar: 'Toggle sidebar',
                    toggle_theme: 'Toggle theme',
                },
            },
            ctrl_left: {
                title1: 'Controls',
                title2: '(Left)',
                items: {
                    mouse_sel: 'Mouse select / Hand mode',
                    table: 'Table',
                    line: 'Line',
                    area: 'Area',
                    note: 'Sticky note',
                    comment: 'Comment',
                    pen: 'Drafting pen',
                    undo: 'Undo',
                    redo: 'Redo',
                },
            },
            ctrl_top_left: {
                title1: 'Controls',
                title2: '(Top)',
                items: {
                    export_img: 'Export image',
                    search: 'Search',
                    editor_panel: 'Editor',
                    zoom_to_fit: 'Zoom to fit',
                },
            },
            ctrl_bottom_right: {
                title1: 'Controls',
                title2: '(Bottom)',
                items: {
                    minimap: 'Minimap',
                    full_screen: 'Full screen',
                    zoom_in: 'Zoom in',
                    zoom_out: 'Zoom out',
                    zoom_100: 'Zoom to 100%',
                },
            },
            ctx_tab: {
                title1: 'Context Menu',
                title2: '(Table)',
                items: {
                    dupl_tab: 'Duplicate table',
                    del_tab: 'Delete table',
                },
            },
            ctx_del_tab: {
                title1: 'Context Menu',
                title2: '(Confirm Delete)',
                items: {
                    yes: 'Delete',
                    no: 'Cancel',
                },
            },
            ctx_tab_col: {
                title1: 'Context Menu',
                title2: '(Column)',
                items: {
                    add_col_below: 'Add column below',
                    focus_col_above: 'Focus on column above',
                    focus_col_below: 'Focus on column below',
                    move_col_up: 'Move column up',
                    move_col_down: 'Move column down',
                    dupl_col: 'Duplicate column',
                    del_col: 'Delete column',
                },
            },
            ctx_line: {
                title1: 'Context Menu',
                title2: '(Line)',
                items: {
                    del_line: 'Delete line',
                },
            },
            ctx_area: {
                title1: 'Context Menu',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplicate area',
                    del_area: 'Delete area',
                },
            },
            ctx_multi: {
                title1: 'Context Menu',
                title2: '(Multi Select)',
                items: {
                    select_all: 'Select all elements',
                    create_area_for_select_els: 'Create area for selected elements',
                    dupl_select_els: 'Duplicate selected elements',
                    del_select_els: 'Delete selected elements',
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'Selection',
                table: 'Table',
                line: 'Line',
                area: 'Area',
                note: 'Sticky note',
                comment: 'Comment',
                pen: 'Pen',
                undo: 'Undo',
                redo: 'Redo',
            },
            ctrl_top_left: {
                home: 'Home',
                name: 'Diagram information',
                editor: 'Editor',
                search: 'Search',
                export: 'Export',
                view_mode: 'View mode',
                zoom_to_fit: 'Zoom to fit',
                grid: 'Grid layout',
                history: 'History',
                main_menu: 'Main menu',
                new_diagram: 'New diagram',
            },
            ctrl_top_right: {
                feature_req: 'Feature Request',
                feedback: 'Send feedback',
                sign_in: 'Sign In',
                quick_share: 'Quick Share',
            },
            ctrl_bottom_right: {
                full_screen: 'Full screen',
                minimap: 'Minimap',
                zoom_out: 'Zoom out',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Zoom in',
                info: 'Information & Resources',
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Default',
                        blue: 'Blue',
                        green: 'Green',
                        red: 'Red',
                        purple: 'Purple',
                        violet: 'Violet',
                    },
                    borders: {
                        none: 'None',
                        solid: 'Solid',
                        dashed: 'Dashed',
                        dotted: 'Dotted',
                    },
                    color: 'Color',
                    border: 'Border',
                    description: 'Description',
                    description_table_place: 'Description',
                    description_column_place: 'Description',
                    description_line_place: 'Description',
                    description_note_place: 'Description',
                    description_area_place: 'Description',
                    description_pen_place: 'Description',
                    hide_menu: 'Hide menu',
                    show_menu: 'Show menu',
                },
                tab_col: {
                    add_col_below: 'Add column below',
                    add_col_above: 'Add column above',
                    key: 'Key',
                    keys: {
                        none: 'None',
                        pk: 'Primary key',
                        fk: 'Foreign key',
                    },
                    index: 'Index',
                    indexes: {
                        none: 'None',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full text',
                    },
                    increment: 'Auto increment',
                    enum: 'Enum',
                    enum_place: 'Enum value',
                    not_null: 'Not nullable',
                    default_value: 'Default value',
                    default_value_place: 'Default value',
                    generated_value: 'Generated value',
                    generated_value_place: 'Generated value',
                    check: 'Check',
                    check_place: 'Check value',
                    move_col_down: 'Move column down',
                    move_col_up: 'Move column up',
                    more_functions: 'More functions'
                },
                line: {
                    change_connects: 'Change connectors',
                    connects: {
                        empty: 'Empty',
                        one_to: 'One to',
                        many_to: 'Many to',
                        one_many_to: 'One or Many to',
                        one_null_to: 'One / Null to',
                        many_null_to: 'Many / Null to',
                    },
                    on_update: 'On update trigger',
                    on_delete: 'On delete trigger',
                },
                area: {
                    filter: 'Filter elements',
                },
                note: {
                    link_placeholder: 'Enter a link',
                    link_apply: 'Add',
                    link_remove: 'Remove',
                    link_edit: 'Edit',
                    link_needs_selection: 'Select text to link',
                    bulleted_list: 'List',
                    numbered_list: 'Numbered list',
                    font_style: 'Font style',
                    alignment: 'Alignment',
                    align_left: 'Left',
                    align_center: 'Center',
                    align_right: 'Right',
                    link: 'Link',
                    monospace: 'Monospace',
                    bold: 'Bold',
                    italic: 'Italic',
                    underline: 'Underline',
                    strikethrough: 'Strikethrough',
                },
                multi: {
                    filter: 'Filter selection',
                    create_area: 'Create area',
                },
            },
        },
        dropdown_ctrl_view_modes: {
            full: 'Columns',
            keys_only: 'Keys',
            names_only: 'Names only',
        },
        dropdown_ctrl_grid: {
            none: 'None',
            lines: 'Lines',
            dots: 'Dots',
        },
        dropdown_ctrl_export: {
            export_img: 'Export image',
            export_code: 'Export code',
        },
        dropdown_ctrl_settings: {
            back_home: 'Back home',
            sign_in: 'Sign In',
            preferences: 'Preferences',
            new_project: 'New diagram',
            import_diagram: 'Import diagram',
            duplicate_diagram: 'Duplicate diagram',
            keyboard_shortcuts: 'Keyboard shortcuts',
            languages: 'Languages',
            view: 'View',
            upgrade_plan: 'Upgrade plan',
            language: 'Language',
            mouse_trackpad: 'Mouse or trackpad',
            background_color: 'Background color',
            grid_layout: 'Grid layout',
            view_mode: 'View mode',
            show_align_lines: 'Show align lines',
            show_members_cursors: "Show members cursors",
            show_comments: 'Show comments',
            undo_redo_controls: 'Undo/redo controls',
            show_scrollbars: 'Show scrollbars',
            opt_auto: 'Auto',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Mouse',
            opt_default: 'Dark (default)',
            opt_gray: 'Gray',
            opt_blue: 'Blue',
            opt_purple: 'Purple',
            opt_violet: 'Violet',
            opt_green: 'Green',
            opt_red: 'Red',
            opt_yellow: 'Yellow',
            opt_dots: 'Dots',
            opt_lines: 'Lines',
            opt_none: 'None',
            opt_full: 'Full',
            opt_keys: 'Keys',
            opt_names: 'Names',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Send feedback',
            keyboard_shortcuts: 'Keyboard shortcuts',
            languages: 'Languages',
            homepage: 'Homepage',
        },
        n: {
            default: 'Loading...',
            file_ready_to_download: 'The file is ready to download',
            code_copied: 'Code copied to clipboard',
            link_copied: 'Link copied to clipboard',
            username_copied: 'Username copied to clipboard',
            email_copied: 'Email copied to clipboard',
            please_enter_message: 'Enter a message',
            invalid_email: 'Email is not valid',
            // Notify.jsx looks messages up as `n.${message}` with no options
            // object of its own (see notify.actions.js's showNotify), so this
            // can't be a `{{protocol}}`-interpolated string the way
            // m_export_code.title is (t(key, { db_engine }) at its own call
            // site) — kept static; NoteLinkMenu's popover itself stays open
            // with the offending value still in the input, so the user isn't
            // left guessing which protocol was rejected.
            note_link_unsupported_protocol: "Link type not supported. Use https, http, mailto.",
            something_wrong_contact: 'Something went wrong', //. Please try to reload the page or contact us.',
            something_wrong: 'Unable to complete this action. Please contact us.', //' Please try to reload the page.',
            sending: 'Sending...',
            request_sent: 'Request sent. Thank you!',

            please_enter_email: 'Enter email address',
            changing: 'Changing...',
            role_changed: 'Role changed',
            removing: 'Removing...',
            member_removed: 'Member removed',
            inviting: 'Inviting...',
            invite_sent: 'Invite sent', // 'The invite has been sent'
            added_to_diagram: 'Added to the diagram',
            invite_removed: 'Invite removed',
            role_not_allowed_on_plan: "This role isn't available on your plan. Upgrade to assign it.",
            already_diagram_member: 'This person already has access to the diagram.',
            cannot_invite_to_workspace: 'Ask a workspace admin to invite this person to the workspace.',
            saving: 'Saving...',
            saved: 'Saved',
            diagram_renamed: 'Diagram renamed',
            diagram_updated: 'Diagram updated',
            duplicating: 'Duplicating...',
            diagram_duplicated: 'Diagram duplicated',
            deleting: 'Deleting...',
            diagram_archived: 'Diagram archived',
            diagram_deleted: 'Diagram deleted',
            restoring: 'Restoring...',
            diagram_restored: 'Diagram restored',
            diagram_pinned: 'Diagram pinned',
            diagram_unpinned: 'Diagram unpinned',
            creating: 'Creating...',
            diagram_created: 'Diagram created',
            forbidden: "You don't have access to that.",
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Already a workspace member',
            cannot_invite_self: "You can't invite yourself",
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagram not found.',
            has_diagram_members: 'Diagram has active members',
            seat_limit_reached: "You've reached the seat limit on your plan. Upgrade to invite more people.",
            feature_not_in_plan: "This feature isn't included in your current plan.",
            subscription_expired: 'Your subscription has expired. Renew to keep using this.',
            subscription_inactive: 'Your subscription is inactive. Please update billing.',
            plan_limit_generic: "Your plan doesn't allow this action. Upgrade to continue.",

            // Auth / profile
            session_expired: 'Your session has expired — please sign in again.',
            profile_updated: 'Profile updated',
            profile_update_failed: 'Failed to update profile.',
            account_delete_failed: 'Failed to delete account.',

            // Preferences
            couldnt_save: "Couldn't save changes",
            try_again: 'Something went wrong. Please try again.',

            // Workspace
            not_workspace_member: "You're not a member of that workspace.",
            workspace_switch_failed: "Couldn't switch workspace. Please try again.",
            workspace_create_failed: "Couldn't create workspace. Please try again.",
            invalid_workspace_name: 'Invalid workspace name',
            workspace_updated: 'Workspace updated',
            workspace_update_failed: "Couldn't update workspace. Please try again.",
            last_owner_cannot_leave: "You're the only owner. Make someone else an owner, or delete the workspace, before leaving.",
            workspace_leave_failed: "Couldn't leave workspace. Please try again.",
            workspace_delete_forbidden: 'Only the workspace owner can delete this workspace.',
            workspace_has_active_billing: "Cancel this workspace's subscription before deleting it.",
            workspace_deleted: 'Workspace deleted',
            workspace_delete_failed: "Couldn't delete workspace. Please try again.",
            member_remove_forbidden: "You don't have permission to remove this member.",
            member_remove_failed: "Couldn't remove member. Please try again.",
            cannot_remove_self: 'Use "Leave workspace" to remove yourself.',
            cannot_remove_last_owner: 'A workspace must always have an owner. Make someone else an owner first.',
            invite_revoke_forbidden: "You don't have permission to revoke this invite.",
            invite_revoke_failed: "Couldn't revoke invite. Please try again.",
        },
        dashboard: {
            doc_title: 'Diagrams',
            filter_all: 'All',
            filter_mydiagrams: 'My diagrams',
            filter_shared: 'Shared with me',
            filter_archived: 'Archived',
            empty_all: 'No diagrams in "All diagrams"',
            empty_mydiagrams: 'No diagrams in "My diagrams"',
            empty_shared: 'No diagrams in "Shared with me"',
            empty_archived: 'No diagrams in "Archived"',
            example_diagram_badge: 'Example diagram',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Back to app',
                group_personal: 'Personal',
                group_organization: 'Organization',
                billing: 'Billing',
            },
            profile: {
                member_since: 'Member since {{date}}',
                general: 'General',
                email: 'Email',
                full_name: 'Full name',
                full_name_placeholder: 'Enter name',
                account_protection: 'Account protection',
                mfa_label: 'Multi-factor authentication (MFA)',
                mfa_sub: 'Additional layer of security to account · Coming soon',
                mfa_enable: 'Enable MFA',
                mfa_soon_tooltip: 'Will be available soon',
                workspace_access: 'Workspace access',
                leave_workspace: 'Leave workspace',
                leave_workspace_sub: 'Remove yourself from the workspace',
                leave_owner_tooltip: 'Transfer ownership before leaving workspace',
            },
            workspace: {
                header: 'Workspace',
                general: 'General',
                name_label: 'Workspace Name',
                name_placeholder: 'workspace name',
                stat_member_singular: 'Member',
                stat_member_plural: 'Members',
                stat_team_singular: 'Team',
                stat_team_plural: 'Teams',
                members_section: 'Members',
                no_members: 'No members',
                count_member_singular: 'member',
                count_member_plural: 'members',
                view_members_btn: 'View members',
                danger_zone: 'Danger zone',
                delete_workspace: 'Delete workspace',
                delete_workspace_sub: 'This will permanently delete workspace',
                delete_owner_only_tooltip: 'Only owners can delete workspaces',
                delete_cancel_sub_tooltip: 'Cancel your subscription before deleting workspace',
            },
            members: {
                header: 'Members',
                col_name: 'Name',
                col_email: 'Email',
                col_role: 'Role',
                col_joined: 'Joined',
                active_members: 'Active members',
                invited_section: 'Invited',
                no_members: 'No members yet.',
                options_aria: 'Options',
                leave_workspace_item: 'Leave workspace...',
                remove_member_item: 'Remove member...',
                remove_owner_only_tooltip: 'Only owners can remove members',
                remove_owner_row_tooltip: "The owner can't be removed from the workspace",
                remove_invite_item: 'Remove invite...',
                role_invited_suffix: '{{role}} (Invited)',
            },
            preferences: {
                section_general: 'General',
                section_diagram_defaults: 'Diagram Settings',
                section_diagram_views: 'Diagram Views',
                section_notifications: 'Notifications',
                theme_label: 'Interface theme',
                theme_sub: 'Select your interface color scheme',
                theme_dark: 'Dark',
                theme_light: 'Light',
                theme_system: 'System',
                language_sub: 'Select your interface language',
                timezone_label: 'Timezone',
                timezone_sub: 'Select your timezone',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Pacific Time',
                    denver: 'GMT-07:00 — Mountain Time',
                    chicago: 'GMT-06:00 — Central Time',
                    new_york: 'GMT-05:00 — Eastern Time',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azores',
                    london: 'GMT+00:00 — London',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyiv, Athens',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — India',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Jakarta',
                    shanghai: 'GMT+08:00 — Beijing, Singapore',
                    tokyo: 'GMT+09:00 — Tokyo, Seoul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Choose canvas navigation controls',
                background_sub: 'Choose a background color for the canvas',
                grid_sub: 'Choose the canvas grid layout',
                show_align_lines_sub: 'Show lines when aligning objects',
                show_cursors_sub: 'Show other collaborators cursors',
                show_comments_sub: 'Show comments on the canvas',
                show_scrollbars_sub: 'Show scrollbars while navigating the canvas',
                show_undo_redo_label: 'Show undo/redo controls',
                show_undo_redo_sub: 'Show controls for undoing and redoing changes',
                notif_shared_label: 'Diagram shared with me',
                notif_shared_sub: 'When someone shares a diagram with me',
                notif_mentions_label: 'Mentions in comments',
                notif_mentions_sub: 'When someone @mentions me in a comment',
                notif_updates_label: 'Product updates',
                notif_updates_sub: 'Monthly updates on new features and improvements',
                show: 'Show',
                hide: 'Hide',
                on: 'On',
                off: 'Off',
            },
            billing: {
                header: 'Billing',
                plan_free: 'Free plan',
                status_current: 'Current',
                no_renewal_needed: 'No renewal needed',
                payment_header: 'Payment',
                no_payments: 'No payments',
                invoices_header: 'Invoices',
                no_invoices: 'No invoices',
            },
            usage: {
                doc_title: 'Usage',
                overview_title: 'Overview',
                resource_limits_title: 'Resource Limits',
                label_diagrams: 'Diagrams',
                label_tables: 'Tables',
                label_areas: 'Areas',
                label_notes: 'Sticky Notes',
                label_members: 'Members',
                label_tables_per_diagram: 'Tables / Diagram',
                label_areas_per_diagram: 'Areas / Diagram',
                label_notes_per_diagram: 'Notes / Diagram',
                need_more_title: 'Need more?',
                need_more_free: 'Upgrade to Basic for more diagrams, version history, and priority support.',
                need_more_paid: 'Upgrade to Professional for unlimited diagrams, seats, and advanced features.',
            },
        },
        pages: {
            not_found: {
                page_not_found: "Page not found",
                dont_have_access_to_diagram: "You don't have access to this diagram or it may no longer exist.",
                back_home: "Back home"
            },
            error: {
                title: "Error",
                link_is_invalid: "This link is invalid or was entered incorrectly.",
                something_wrong: "Something went wrong.",
                back_home: "Back home",
                please_try_later: "Please try later",
            },
            billing_success: {
                doc_title: 'Plan upgraded',
                heading: 'Payment Successful',
                subtitle: 'Your plan has been upgraded successfully.',
                cta: 'Start designing',
            },
            email_verified: {
                doc_title: 'Email verified',
            },
            forgot_password: {
                doc_title: 'Forgot password',
            },
            password_updated: {
                doc_title: 'Password updated',
            },
            reset_password: {
                doc_title: 'Reset password',
            },
            check_email: {
                doc_title: 'Check your email',
            },
            sign_in: {
                doc_title: 'Sign In to {{product}}',
            },
            sign_up: {
                doc_title: 'Sign Up for {{product}}',
            },
        },
    },
};

export const enMeta = {
    lang_origin: 'English',
    lang_eng: 'English',
    lang_code: 'en',
};
